import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74a937b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "email-confirm-form" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"side\" data-v-74a937b0><div class=\"side-text-wrap\" data-v-74a937b0><div class=\"welcome-text\" data-v-74a937b0>WELCOME BACK</div><a href=\"/\" data-v-74a937b0><img class=\"logo\" src=\"/images/auth/login-logo.png\" alt=\"\" data-v-74a937b0></a></div></div>", 1)
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mobile-logo",
    src: "/images/auth/login-logo.png",
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "text-dark auth-language-dropdown" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "label required" }
const _hoisted_9 = { class: "msg_1" }

import { useStore } from "@/store";
import { useI18n } from "vue-i18n";

import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Field, Form } from "vee-validate";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Actions } from "@/store/enums/StoreEnums";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import LanguageDropdown from "../../components/LanguageDropdown.vue";
import ClientGlobalService from "@/projects/client/services/ClientGlobalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmEmail',
  props: {
  code: { type: String, required: true },
  email: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const store = useStore();
const isLoading = ref(false);
const router = useRouter();



onMounted(() => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});

//form submit function
const onConfirmEmail = async () => {
  await store.dispatch(Actions.LOGOUT);

  try {
    isLoading.value = true;
    await ClientGlobalService.confirmEmail({
      ...props,
    });

    MsgPrompt.success(t("tip.pleaseLoginToVerify"), t("tip.confirmSuccess"))
      .then(() => store.dispatch(Actions.LOGOUT))
      .then(() => router.push({ name: "sign-in" }));
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LanguageDropdown)
      ]),
      _createVNode(_unref(Form), {
        class: "email-confirm-form",
        onSubmit: onConfirmEmail
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("title.emailConfirmation")), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("fields.email")), 1),
            _createVNode(_unref(Field), {
              tabindex: "1",
              class: "mt-1 form-control form-control-lg form-control-solid",
              type: "text",
              name: "email",
              autocomplete: "off",
              value: props.email,
              disabled: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(LoadingButton, {
              tabindex: "3",
              type: "submit",
              class: "btn btn-lg w-100 loginBtn",
              "is-loading": isLoading.value,
              "save-title": _ctx.$t('action.confirm')
            }, null, 8, ["is-loading", "save-title"]),
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.$t("action.backTo") + " ") + " ", 1),
              _createVNode(_component_router_link, { to: "/sign-in" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.login")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})